import {ContentState, EditorState, SelectionState, Modifier, convertFromHTML} from 'draft-js';
import {mergeTagDecorator} from './mergeTagDecorator';
import {MERGE_TAGS} from './insertMergeTag';

const TOKEN_RE = /\[([a-z]+)\]/g;

const TOKEN_SET = new Set(MERGE_TAGS.map(t => t.token));

function getLabelForToken(token: string): string {
	const tag = MERGE_TAGS.find(t => t.token === token);
	return tag ? tag.label : token;
}

export function htmlToAutoReplyEditorState(html: string): EditorState {
	if (!html || !html.trim()) {
		const empty = ContentState.createFromText('');
		return EditorState.createWithContent(empty, mergeTagDecorator);
	}

	const blocksFromHTML = convertFromHTML(html);
	let content = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);

	const replacements: {blockKey: string; start: number; end: number; token: string}[] = [];

	content.getBlockMap().forEach(block => {
		if (!block) return;
		const blockKey = block.getKey();
		const text = block.getText();
		let match: RegExpExecArray | null;
		TOKEN_RE.lastIndex = 0;
		while ((match = TOKEN_RE.exec(text)) !== null) {
			const token = match[1]!;
			if (TOKEN_SET.has(token)) {
				replacements.push({
					blockKey,
					start: match.index,
					end: match.index + match[0].length,
					token,
				});
			}
		}
	});

	replacements
		.sort((a, b) => {
			if (a.blockKey !== b.blockKey) return 0;
			return b.start - a.start;
		})
		.forEach(({blockKey, start, end, token}) => {
			const label = getLabelForToken(token);
			const selection = SelectionState.createEmpty(blockKey).merge({
				anchorOffset: start,
				focusOffset: end,
			}) as SelectionState;

			const contentWithEntity = content.createEntity('MERGE_TAG', 'IMMUTABLE', {token, label});
			const entityKey = contentWithEntity.getLastCreatedEntityKey();

			content = Modifier.replaceText(contentWithEntity, selection, label, undefined, entityKey);
		});

	return EditorState.createWithContent(content, mergeTagDecorator);
}
